import { devtools, persist } from '@bomdisoft/store/middleware';
import { create } from '@bomdisoft/store/react';

type PhoneInputStore = {
  extension: string;
  number: number | null;
  setPhoneExtension: (extension: string) => void;
  setPhoneNumber: (number: number | null) => void;
};

export const usePhoneInputStore = create<PhoneInputStore>()(
  devtools(
    persist(
      (set, _get) => ({
        extension: '+237',

        number: null,
        setPhoneExtension: (extension: string) => {
          set({ extension });
        },
        setPhoneNumber: (number: number | null) => {
          set({ number });
        },
      }),
      { name: 'bomdisoft-phone-input-storage' },
    ),
  ),
);
